import { UnitSystem } from '../constants/supportedUnitSystems';

const useUnitSystem = () => {
  const unitSystem: UnitSystem = localStorage.calculatorPreviewCulture || localStorage.culture || 'en-GB';

  return { unitSystem };
};

export default useUnitSystem;
